'use client';

import { WckReNewalPRT } from '@hooks/appInterface';
import useWckAppFunction from '@hooks/useWckAppInterface';
import React, { useEffect } from 'react';

function WckNatvieInterFace() {
  const WCKAppFunction = useWckAppFunction();

  useEffect(() => {
    window.WCK_COMMON_RENEWAL_PRT = WckReNewalPRT();
    window.WCKAppFunction = WCKAppFunction;
    window.disableAlarmComplete = WCKAppFunction.disableAlarmComplete;
    window.enableAlarmComplete = WCKAppFunction.enableAlarmComplete;
  }, []);

  return <></>;
}

export default WckNatvieInterFace;
